import { render, staticRenderFns } from "./Registration.vue?vue&type=template&id=11d7a7f1&scoped=true"
import script from "./Registration.vue?vue&type=script&lang=js"
export * from "./Registration.vue?vue&type=script&lang=js"
import style0 from "./Registration.vue?vue&type=style&index=0&id=11d7a7f1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11d7a7f1",
  null
  
)

export default component.exports